<template>
	<div class="wrapindex">	
		<div class="content">
			<router-view></router-view>
		</div>
	</div>
</template>
<script>
    import cIndex from '@/components/header'
	const components = {
		cIndex
	}
	import store from '../vuex/store';
	import {
		mapGetters
	} from 'vuex';
	export default {
		components: components,
		name: 'hello',
		store,
		computed: {
			...mapGetters([
				'ind'
			])
		},
	}
</script>
<style lang="scss">
	@import "../styles/core/reset.scss";
	.wrapindex {
		width: 100%;
		height: 100%;
		@include flexbox;
		@include flex-direction(column);
		position: relative;
		.header {
			width: 100%;
			height: .8rem;
			background: #467DE5;
			box-shadow: inset 0 -1px 4px #c3c3c3;
			z-index: 999;
			position: relative;
			.header-conten {
				width: 12rem;
				height: 100%;
				margin: 0 auto;
				h2 {
					line-height: .8rem;
					font-size: .18rem;
					color: #FFFFFF;
					font-weight: normal;
					img {
						display: inline-block;
						width: 1rem;
						height: .2rem;
						padding-right: 30px;
					}
				}
				ul {
					float: right;
					width: .94rem;
					height: .8rem;
					@include flexbox;
					align-items: center;
					li {
						@include flex;
						color: #fff;
						font-size: .16rem;
						&:last-child {
							text-align: right;
						}
						;
					}
					li:hover {
						cursor: pointer;
					}
				}
				.dropdowns {
					float: right;
					width: 2rem;
					height: .8rem;
					.el-dropdown {
						width: 100%;
						height: 100%;
						display: block;
					}
					h4 {
						font-size: 16px;
						color: #FFFFFF;
						line-height: .8rem;
						@include flexbox;
						cursor: pointer;
						span {
							@include flex;
							text-align: center;
							font-size: .16rem;
							&:last-child {
								text-align: center;
							}
							;
						}
					}
				}
			}
			.router-nav {
				position: absolute;
				width: 2.4rem;
				height: .8rem;
				top: 0;
				left: 55%;
				ul {
					width: 100%;
					height: 100%;
					@include flexbox;
					justify-content: center;
					align-items: center;
					li {
						@include flex;
						text-align: center;
						font-size: .16rem;
						color: #FFFFFF;
						width: 100%;
						height: 100%;
						line-height: .8rem;
						p {
							width: 100%;
							height: 100%;
							cursor: pointer;
							&.router-link-exact-active {
								background: #376ED5;
							}
						}
					}
				}
			}
		}
		.content {
			flex: 1;
			width: 100%;
			height: 100%;
			/*overflow-y: auto;*/
			/*background: #F4F5F8;*/
		}
		
		.mark {
			width: 100%;
			height: 100%;
			position: absolute;
			background: rgba(0, 0, 0, 0.3);
			top: 0;
			left: 0;
			z-index: 99999;
			.mark-content {
				@include flexbox;
				@include flex-direction(column);
				width: 8.5rem;
				height: 5.07rem;
				background: #fff;
				border-radius: 4px;
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				h3 {
					height: .82rem;
					border-bottom: 1px solid #eee;
					line-height: .82rem;
					text-align: center;
					position: relative;
					font-size: .16rem;
					.guanbi {
						position: absolute;
						width: .16rem;
						height: .16rem;
						right: .25rem;
						top: 50%;
						margin-top: -.08rem;
					}
					.guanbi:hover {
						cursor: pointer;
					}
				}
				.myfrom {
					@include flex;
					width: 100%;
					padding-top: .42rem;
					.el-form {
						width: 3.6rem;
						margin: 0 auto;
						.el-form-item {
							.el-form-item__label{
								float: left;
							}
							.el-form-item__content {
								height: .4rem;
								clear: both;
								.el-input__inner {
									background: #F4F5F8;
									border-radius: 4px;
									height: .4rem;
									clear: both;
								}
								.el-form-item__error {
									color: #ff4949;
									font-size: 0.12rem;
									line-height: 40px;
									position: absolute;
									top: 0;
									right: 8px;
									padding: 0 8px;
									left: auto;
								}
								.regInput {
									width: 3rem;
								}
								.regCode {
									width: 2rem;
									height: .4rem;
								}
								button{
									width: 1.5rem;
								    height: .4rem;
								    margin-left: .05rem;
								    cursor: pointer;
								    line-height: .4;
								}
								b {
									display: inline-block;
									background: #F4F5F8;
									border: 1px solid #EEEEEE;
									border-radius: 4px;
									text-align: center;
									line-height: .4rem;
									font-size: 14px;
									color: #555555;
									box-sizing: border-box;
								}
								b {
									width: .5rem;
									height: .4rem;
									margin-right: .05rem;
									font-weight: normal;
								}
								em {
									width: 1.5rem;
									height: .4rem;
									margin-left: .05rem;
									cursor: pointer;
								}
							}
						}
						button{
							font-size: .16rem;
						}
						.reg-text {
							.but{
								display: inline-block;
								width: 1.5rem;
								height: .4rem;
								text-align: center;
								line-height: .4rem;
								background: #F4F5F8;
								border: 1px solid #bfcbd9;
								border-radius: 4px;
								color: #555;
								box-sizing: border-box;
								cursor: pointer;
							}
							.el-form-item__content{
								.el-form-item__error {
									color: #ff4949;
									font-size: 0.12rem;
									line-height: 40px;
									position: absolute;
									top: 0;
									right: 161px;
									padding: 0 8px;
									left: auto;
								}
							}
							
						}
					}
					.forgotPassword {
						display: block;
						text-align: right;
						font-size: .14rem;
						color: #999;
						cursor: pointer;
					}
					.myfrom-buttons {
						width: 1.2rem;
						height: .35rem;
						background: #467DE5;
						color: #fff;
						box-shadow: 0 2px 4px #c3c3c3;
						border: none;
						border-radius: 0;
						position: absolute;
						left: 50%;
						bottom: .6rem;
						margin-left: -.6rem;
					}
					.myfrom-footer {
						position: absolute;
						width: 1.2rem;
						bottom: .3rem;
						text-align: center;
						left: 50%;
						margin-left: -.6rem;
						font-size: .14rem;
						color: #999999;
						cursor: pointer;
						img {
							padding-left: .06rem;
						}
					}
				}
			}
		}
		.nullMark {
			width: 100%;
			height: 100%;
			position: absolute;
			background: rgba(0, 0, 0, 0.3);
			top: 0;
			left: 0;
			z-index: 99999;
			.null-content {
				width: 8.5rem;
				height: 5.07rem;
				background: #fff;
				border-radius: 4px;
				box-shadow: 0 0 3px #C3C3C3;
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				@include flexbox;
				@include flex-direction(column);
				h3 {
					height: .6rem;
					line-height: .6rem;
					text-align: center;
					font-size: 16px;
					color: #555555;
					border-bottom: 1px solid #eee;
					position: relative;
					.guanbi {
						position: absolute;
						width: .16rem;
						height: .16rem;
						right: .25rem;
						top: 50%;
						margin-top: -.08rem;
					}
					.guanbi:hover {
						cursor: pointer;
					}
				}
				div {
					@include flex;
					width: 100%;
					position: relative;
					img {
						position: absolute;
						left: 50%;
						top: .6rem;
						transform: translate(-50%, 0);
					}
					p {
						position: absolute;
						top: 1.8rem;
						left: 50%;
						transform: translate(-50%, 0);
						font-size: 16px;
						color: #555555;
					}
					button {
						width: 1.2rem;
						height: .35rem;
						background: #467DE5;
						border: none;
						color: #fff;
						box-shadow: 0 2px 4px #c3c3c3;
						position: absolute;
						bottom: .6rem;
						left: 50%;
						transform: translate(-50%, 0);
						font-size: .14rem;
						cursor: pointer;
					}
				}
			}
		}
	}
	
	.el-dropdown-menu {
		width: 1.47rem;
		height: 18.4%;
		@include flexbox;
		@include flex-direction(column);
		li {
			@include flex;
			width: 100%;
			margin: 0;
			padding: 0;
			@include flexbox;
			align-items: center;
			border-bottom: 1px solid #eee;
			&:last-child {
				border-bottom: none;
			}
			;
			p {
				@include flex;
				width: 1.86rem;
				padding-left: .3rem;
				font-size: .16rem;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// index.vue?00d40c1a